import { ArrowDown } from "lucide-react";
import { HeroSlider } from "@/components/HeroSlider";
import { Reveal } from "@/components/Motion";
import { scrollToTarget } from "@/components/SmoothScroll";

const muted = { color: "var(--kh-text-muted)" };

const PARAGRAPHS = [
  "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
  "Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  "Curabitur pretium tincidunt lacus. Nulla gravida orci a odio. Nullam varius, turpis et commodo pharetra, est eros bibendum elit, nec luctus magna felis sollicitudin mauris. Integer in mauris eu nibh euismod gravida.",
  "Praesent blandit odio eu enim. Pellentesque sed dui ut augue blandit sodales. Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; aliquam nibh. Mauris ac mauris sed pede pellentesque fermentum.",
];

const CaseStudy = ({ n }) => (
  <section id={`case-study-${n}`} className="px-6 sm:px-10 lg:px-14 py-24 lg:py-32" style={{ background: n % 2 ? "var(--kh-surface)" : "var(--kh-bg)" }} data-testid={`case-study-${n}`}>
    <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <Reveal className="lg:sticky lg:top-32">
          <div className="kh-mono mb-4" style={{ color: "var(--kh-accent)" }}>Client story · {String(n).padStart(2, "0")}</div>
          <h2 className="kh-serif text-4xl lg:text-5xl leading-[1.05]">Case Study {n}</h2>
          <p className="mt-5 text-base leading-relaxed" style={muted}>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </Reveal>
      </div>
      <div className="lg:col-span-8 space-y-6">
        {PARAGRAPHS.slice(0, 2).map((p) => (
          <Reveal key={p}><p className="text-base sm:text-lg leading-relaxed" style={muted}>{p}</p></Reveal>
        ))}
        <Reveal>
          <blockquote className="kh-serif text-2xl sm:text-3xl leading-snug py-6 pl-6 my-4" style={{ borderLeft: "2px solid var(--kh-accent)" }} data-testid={`case-study-${n}-quote`}>
            “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.”
          </blockquote>
        </Reveal>
        {PARAGRAPHS.slice(2).map((p) => (
          <Reveal key={p}><p className="text-base sm:text-lg leading-relaxed" style={muted}>{p}</p></Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default function CaseStudiesPage() {
  return (
    <main data-testid="case-studies-page">
      <HeroSlider only="cases" short action={
        <button type="button" className="kh-btn-primary" onClick={() => scrollToTarget(document.getElementById("case-study-1"))} data-testid="hero-read-more-button">
          Read More <ArrowDown size={16} className="kh-arrow-down" aria-hidden="true" />
        </button>
      } />
      <CaseStudy n={1} />
      <CaseStudy n={2} />
      <CaseStudy n={3} />
    </main>
  );
}
